import { format, isAfter, parseISO, startOfToday } from 'date-fns';

export const getAbsenceReasonLabel = (reason: AbsenceReason | null): string => {
  if (reason === null) return 'Não justificada';

  const labels: Record<AbsenceReason, string> = {
    HealthIssuesWithSickNote: 'Problemas de saúde com atestado',
    HealthIssuesWithoutSickNote: 'Problemas de saúde sem atestado',
    FamilyMatters: 'Questões familiares',
    TransportationProblems: 'Problemas de transporte',
    Other: 'Outros',
  };

  return labels[reason] || 'Motivo desconhecido';
};

export const getAbsenceReasonOptions = () => {
  return [
    { value: 'HealthIssuesWithSickNote', label: 'Problemas de saúde com atestado' },
    { value: 'HealthIssuesWithoutSickNote', label: 'Problemas de saúde sem atestado' },
    { value: 'FamilyMatters', label: 'Questões familiares' },
    { value: 'TransportationProblems', label: 'Problemas de transporte' },
    { value: 'Other', label: 'Outros' },
  ];
};

export const formatAbsenceDate = (date: string): string => format(parseISO(date), 'dd/MM/yyyy');

export const isAbsenceDateValid = (date: string): boolean => !isAfter(parseISO(date), startOfToday());

export const getTodayDateString = (): string => format(new Date(), 'yyyy-MM-dd');
